import { createBrowserRouter, Navigate } from 'react-router-dom';
import { publicRoutes, scopedRoutes } from '@/app/routes';
import { auth } from '@/shared/auth/storage';
import { ShellLayout } from '@/features/shell/ShellLayout';
import { LoginPage } from '@/features/auth/LoginPage';
import { SelectScopePage } from '@/features/auth/SelectScopePage';
import { QueuePage } from '@/features/queue/QueuePage';
import { CustomersPage } from '@/features/customers/CustomersPage';
import { ReportsPage } from '@/features/reports/ReportsPage';
import { ShiftPage } from '@/features/shift/ShiftPage';
import { SettingsPage } from '@/features/settings/SettingsPage';

/* Root: нэвтэрсэн + scope cache-тэй бол шууд самбар руу */
function RootRedirect() {
  const cache = auth.getScopeCache();
  if (auth.isAuthed && cache.tenantId && cache.companyId) {
    return <Navigate to={`/${cache.tenantId}/${cache.companyId}/${scopedRoutes.queue}`} replace />;
  }
  return <Navigate to={auth.isAuthed ? publicRoutes.selectScope : publicRoutes.login} replace />;
}

export const router = createBrowserRouter([
  { path: '/', element: <RootRedirect /> },
  { path: publicRoutes.login, element: <LoginPage /> },
  { path: publicRoutes.selectScope, element: <SelectScopePage /> },
  {
    path: '/:tenantId/:companyId',
    element: <ShellLayout />,
    children: [
      { index: true, element: <Navigate to={scopedRoutes.queue} replace /> },
      { path: scopedRoutes.queue, element: <QueuePage /> },
      { path: scopedRoutes.customers, element: <CustomersPage /> },
      { path: scopedRoutes.reports, element: <ReportsPage /> },
      { path: scopedRoutes.shift, element: <ShiftPage /> },
      { path: scopedRoutes.settings, element: <SettingsPage /> },
    ],
  },
  { path: '*', element: <RootRedirect /> },
]);
